import EventCreate from './eventCreate';

export default EventCreate;